import ClearingAPI from '@shared/api';

export const {
    transferReports: { getTransactions, patchTransactions },
} = ClearingAPI.settings;
